<template>
  <div
    class="medical-record-item lightGray pa-3 d-flex flex-row align-center justify-space-between"
  >
    <p class="ma-0">
      {{ mode === 'psychologist' ? appointmentData.patient_name : appointmentData.psychologist_name }}
    </p>

    <div class="d-flex flex-row align-center justify-center mr-5">
      <v-icon size="32" color="primary" class="mr-1">date_range</v-icon>
      <p class="mb-0" style="margin-top: 2px">
        {{ appointmentData.date | formatDate }}
      </p>

      <p class="ma-0 ml-3 text-h6 secondary--text">
        {{
          value ? value.toLocaleString('pt-PT', {
            style: 'currency',
            currency: 'EUR',
          }) : '€ 0,00'
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentRecordItem',
  data() {
    return {
      value: 0,
    };
  },
  props: {
    appointmentData: Object,
    mode: String,
  },
  mounted() {
    if (this.appointmentData.pt_value) {
      this.value = parseFloat(this.appointmentData.pt_value);
    } else {
      this.value = 0;
    }
  },
};
</script>

<style lang="css" scoped>
.medical-record-item {
  background-color: #fff;
}

@media screen and (max-width: 420px) {
  .medical-record-item {
    background-color: #f9f9f9;
  }
}
</style>
